// frontend/src/components/PageHeader.tsx
//
// Унифицированный page header: иконка + title + description + slot для
// контролов справа (period selector, filters etc.)

import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

interface PageHeaderProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  rightSlot?: ReactNode;
}

export function PageHeader({ icon: Icon, title, description, rightSlot }: PageHeaderProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 16,
        marginBottom: 24,
        paddingBottom: 16,
        borderBottom: "1px solid var(--border-default)",
      }}
    >
      <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
        {Icon && (
          <div
            style={{
              width: 40, height: 40, borderRadius: 10,
              background: "linear-gradient(135deg, #0EA5E9 0%, #14B8A6 100%)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#FFFFFF",
              boxShadow: "0 2px 12px rgba(14,165,233,0.25)",
              flexShrink: 0,
            }}
          >
            <Icon size={22} strokeWidth={2} />
          </div>
        )}
        <div>
          <h2 style={{ margin: 0, fontSize: 22, color: "var(--text-primary)", fontWeight: 700, lineHeight: 1.2 }}>
            {title}
          </h2>
          {description && (
            <div style={{ fontSize: 13, color: "var(--text-secondary)", marginTop: 2 }}>
              {description}
            </div>
          )}
        </div>
      </div>
      {rightSlot && <div style={{ display: "flex", alignItems: "center", gap: 8 }}>{rightSlot}</div>}
    </div>
  );
}
